export default "__VITE_ASSET__BiauOk1f__"